export function checkIsNode(event: EventTarget | null): event is Node {
  if (!event || !(event instanceof Node)) {
    return false;
  }
  return true;
}
